import React from 'react';
import { formatParticipation } from '../utils/formatParticipation';
import './ParticipationRate.css';

// Renders an activity count as a participation rate: "<n> of <total> users (<pct>%)"
// (feature 024). Text-only — meaning is carried by the words/number, never colour
// alone (FR-008) — and uses tabular figures so stacked rates align (FR-009).
//
// Props:
//   count  {number}  distinct users who did the activity (numerator)
//   total  {number}  total_user_count for the period + filters (denominator)
//   className {string} optional extra classes for placement
const ParticipationRate = ({ count, total, className = '' }) => {
  const { label } = formatParticipation(count, total);
  return (
    <span className={`participation-rate${className ? ` ${className}` : ''}`}>
      {label}
    </span>
  );
};

export default ParticipationRate;
